import axios from 'axios'
import { PORT } from '../config'

const Moment = require('moment')
const MomentRange = require('moment-range')
const moment = MomentRange.extendMoment(Moment)

export const getRulesFlag = (userData, time, date) => {
  let newdate = moment(date).format('MM-DD-YYYY')
  let flag = false
  if (userData.rules) {
    if (userData.rules[0][newdate] && userData.rules[0][newdate].time) {
      flag = userData.rules[0][newdate].time.includes(time)
      return flag
    }
  }
  return flag
}

export const getAllBookings = (_id) => {
  axios({
    method: 'get',
    url: `${PORT}/getCampusBookingsByInstitutionID`,
    params: {
      institution_id: _id,
    },
  })
    .then((result) => {
      return result.data
    })
    .catch((err) => {
      console.log(err)
    })

  return []
}
